import styled, { css } from 'styled-components';
import * as bp from 'view/styles/breakpoints';
import * as elevation from 'view/styles/elevation';
import * as mixins from 'view/styles/mixins';
import * as zIndex from 'view/styles/z-index';
import Textfield from '@atlaskit/textfield';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const SEARCH_BAR_HEIGHT = token('space.1000', '80px');

export const SearchBarContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
    position: fixed;
    box-sizing: border-box;
    height: ${SEARCH_BAR_HEIGHT};
    width: 100%;
    pointer-events: auto;
    z-index: ${zIndex.searchBar};
`;

export const SearchFieldContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 90vw;
    width: 100%;
    margin: 0 auto;
    padding-right: ${token('space.100', '8px')};
    ${bp.fromMedium.css`
    max-width: 50vw;
    `};
`;

export const InputBackground = styled.div<{ term: string }>`
    &::before {
        ${elevation.e300};
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        /* This should only be shown if term is truthy. */
        opacity: 0;
        /* This pseudo element should not be interactive! Else it blocks clicks to the close button and input. */
        pointer-events: none;
    }

    ${(props) =>
        mixins.applyIf(
            !props.term,
            css`
                &::before {
                    opacity: 1;
                }
            `
        )};
    position: absolute;
    height: ${SEARCH_BAR_HEIGHT};
    left: 0;
    right: 0;
    top: 0;
    z-index: ${zIndex.searchBackground};
    border-bottom: 1px solid ${token('color.border', colors.N30)};
    background-color: ${token('elevation.surface.overlay', colors.N0)};
`;

export const HiddenLabel = styled.label`
    ${mixins.hideVisually};
`;

export const BackButtonContainer = styled.div`
    position: relative;
    left: ${token('space.100', '8px')};
    padding-right: ${token('space.100', '8px')};
    ${bp.fromMedium.css`
    position: absolute;
        margin-left: ${token('space.100', '8px')};
    `};
`;

export const SearchTextField = styled(Textfield)`
    padding-left: ${token('space.025', '2px')};
    height: ${token('space.400', '32px')};
    z-index: ${zIndex.searchBackground + 1};
`;

export const Icon = styled.span`
    margin-left: ${token('space.100', '8px')};
`;
